import React from 'react';
import './WhyNow.css';
import useScrollReveal from '../hooks/useScrollReveal';

function WhyNow() {
  const headerRef = useScrollReveal();
  const cardsRef = useScrollReveal(true);

  return (
    <section id="why-now" className="why-now">
      <div className="section-container">
        <div ref={headerRef} className="reveal">
          <h2 className="section-title">Wieso Sie jetzt handeln sollten</h2>
        </div>

        <div ref={cardsRef} className="why-now-content">
          <div className="why-now-card negative" data-reveal>
            <p>
              Unternehmen, die heute nicht in Automatisierung und KI investieren, verlieren gegenüber innovativeren Wettbewerbern. Ihr Umsatz wird sich schlechter entwickeln, früher oder später beginnt ein anhaltender Kampf ums Überleben der Firma.
            </p>
          </div>

          <div className="why-now-card positive" data-reveal>
            <p>
              Unternehmen, die in Automatisierung und KI investieren, sichern sich kontinuierliches Wachstum, eine verbesserte Mitarbeiterproduktivität und einen erfolgreichen Geschäftsbetrieb, der über Generationen hinweg Bestand hat.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}

export default WhyNow;
